
<svg :width="width" :height="height" viewBox="0 0 36 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM30.5 25L35.992 14.8427L24.4495 15.1651L30.5 25ZM1 2C12.7311 2 19.5549 3.1985 23.5582 5.5213C25.5234 6.66154 26.81 8.07495 27.6741 9.78421C28.5487 11.5144 29.0141 13.5947 29.2532 16.0984L31.2441 15.9082C30.9936 13.2848 30.4924 10.9262 29.459 8.88193C28.415 6.81674 26.8522 5.12021 24.5619 3.7914C20.0545 1.17608 12.7436 0 1 0V2Z"
    :fill="color"
  />
</svg>
